import styled from 'styled-components';
import { getFont } from '@finect/tabular-utils/getFont';
export var Actions = styled.div.withConfig({
  displayName: "Actions",
  componentId: "sc-1bsfz6m-0"
})(["display:flex;align-items:center;justify-content:flex-end;padding:9px 15px;border-radius:", ";background-color:", ";", " font-weight:500;text-align:right;a{position:relative;padding-right:12px;margin-right:3px;color:", ";&:after{position:absolute;top:-3px;bottom:-3px;right:0;border-right:1px solid ", ";content:'';}}"], function (_ref) {
  var theme = _ref.theme;
  return theme.borderRadius;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.colors.uiLL;
}, getFont(-1, 'compact'), function (_ref3) {
  var theme = _ref3.theme;
  return theme.linkColor;
}, function (_ref4) {
  var theme = _ref4.theme;
  return theme.borderColor;
});